<template>
  <div>
    <div class="language-div">
      <LanguageBar />
    </div>

    <div class="loginWrapper">
      <div class="containerSingleBox">
        <div class="loginBox background-white">
          <div class="logo">
            <img src="../../assets/images/up.svg" />
          </div>

          <div class="loginForm">
            <p v-html="$t('superUpInfo')"></p>
            <h3 class="d-flex justify-content-center">{{ invitationData.code }}</h3>
            <div class="text-center">
              <p :class="{ 'text-white': formStyleScope === 'multiben' }">
                <span>{{ $t("superUpApp") }}</span>
              </p>
              <p class="d-flex h-16 justify-content-space-between" >
              <a href="https://apps.apple.com/ro/app/up-mobil/id6720748665">
                <img class="store-img" src="../../assets/images/appstore.png"/>
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.upromania.superup">
                <img class="store-img" src="../../assets/images/gplay.png"/>
              </a>
              </p>
              <p class="d-flex h-16 justify-content-center">
              <a href="https://appgallery.huawei.com/app/C111917809">
                <img class="store-img" src="../../assets/images/hgallery.png"/>
              </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="https://unpkg.com/vue-recaptcha@^1/dist/vue-recaptcha.min.js"></script>
<script>
import httpService from "../../http/http-common.js";
import Cookies from "js-cookie";
import LanguageBar from "@/components/LanguageBar.vue";

export default {
  components: { LanguageBar },
  name: "activate_invite",
  data() {
    return {
      token: "",
      invitationData: null,
      registrationError: null,
      activationCode: "",
    };
  },
  methods: {
    handleSubmit() {
      this.$refs.recaptcha.execute("recaptcha");
    },
    getBeneficiaryInfosForActivation() {
      httpService.beneficiaryService
        .userGetInvitationInfos("uuid=" + this.activationCode, this.token)
        .then(function (response) {
          return response;
        })
        .catch((error) => {
          return error.response;
        })

        // email : userlogin actual
        // code : email-ul pe care a venit invitatia
        // exists: true / false; daca e true nu mai cer parola

        .then((response) => {
          if (response.status == 200) {
            this.invitationData = response.data;
            this.invitationData.password = "";
            this.registrationError = null;
          } else if (response.status == 400) {
            this.invitationData = null;
            this.registrationError = response.data;
          } else {
            this.invitationData = null;
            this.registrationError = { error_code: "ISSS" };
          }
        });
    },
    loadConfigData() {
      var query = window.location.pathname; // Remove question mark
      var parameters = query.split("/");
      this.activationCode = parameters[parameters.length - 1];

      httpService.beneficiaryService
        .requestTokenForRegistration("webopen")
        .then(function (response) {
          // handle success
          return response.data;
        })
        .catch((error) => {
          // handle error
        })
        .then((data) => {
          this.token = data.access_token;
          this.getBeneficiaryInfosForActivation();
        });
    },
  },
  mounted() {
    this.loadConfigData();
  },
};
</script>
<style scoped src="@/assets/styles/login.css"></style>
<style scoped>

  .loginBox {
    height: auto;
    padding-bottom: 20px;
  }

  h6 {
    font-style: italic;
    font-size: 14px;
  }

  .store-img {
    max-height: 55px;
    /* padding: 5px; */
  }
</style>


